import * as exOffcanvas from './utils';

// ----------------------------------------------------------------------------

declare global {
    interface HTMLElement {
        showOffcanvas(config?: Record<string, any>): void;
        hideOffcanvas(config?: Record<string, any>): void;
        toggleOffcanvas(config?: Record<string, any>): void;
    }
}

// ----------------------------------------------------------------------------

HTMLElement.prototype.showOffcanvas = function (config: Record<string, any> = {}): void {
    exOffcanvas.show(this, config);
};

HTMLElement.prototype.hideOffcanvas = function (config: Record<string, any> = {}): void {
    exOffcanvas.hide(this, config);
};

HTMLElement.prototype.toggleOffcanvas = function (config: Record<string, any> = {}): void {
    exOffcanvas.toggle(this, config);
};
